import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Stack } from '@chakra-ui/react';
import { CircleLogo } from '@fluenceur/ui';
import { NavArrowDown, NavArrowUp } from 'iconoir-react';
import { useId, useState } from 'react';
import { useAgentBlocksTextContext } from '../../text/agent-blocks-text-context';
import { TextToggle } from '../shared/TextToggle';
import { TraceLabel } from './TraceLabel';
import { TraceSteps } from './TraceSteps';
/** The size of the icon it replaces, so the toggle's line does not move. */
const TRACE_MARK_SIZE = 14;
/**
 * The live trace above an answer. Open while it runs, so the brand sees the
 * work; folded to "Vérifié en 3 s · 4 sources" once done, unfoldable on demand.
 * A run that stopped short folds to its steps alone ("2 étapes"): it verified
 * nothing. A run that ends folds itself, whatever the brand did while it ran.
 */
export function ReasoningTrace({ status, label = '', steps, durationSeconds = 0, sourceCount = 0 }) {
    const text = useAgentBlocksTextContext();
    const stepsId = useId();
    // The brand's choice only holds for the status it was made in.
    const [toggled, setToggled] = useState(null);
    const open = toggled && toggled.status === status ? toggled.open : status === 'running';
    const Chevron = open ? NavArrowUp : NavArrowDown;
    // The round Fluenceur mark, white on the brand lilac (lilac.600) in both
    // schemes, as on the registered-creator badge. Not `agent.accent`, which
    // lightens in dark mode for the shimmer and the pulse.
    const mark = _jsx(CircleLogo, { size: TRACE_MARK_SIZE, bg: "lilac.600", "aria-hidden": "true" });
    // Done without reading anything: a line of fact, with nothing to unfold.
    if (status === 'done' && steps.length === 0) {
        return (_jsxs(Flex, { align: "center", gap: "1.5", minH: "8", textStyle: "agent.label", color: "agent.fgMuted", children: [mark, _jsx("span", { children: text.trace.done(durationSeconds, sourceCount) })] }));
    }
    return (_jsxs(Stack, { gap: "1", children: [_jsxs(TextToggle, { "aria-expanded": open, "aria-controls": open ? stepsId : undefined, onClick: () => setToggled({ status, open: !open }), children: [mark, status === 'running' ? (_jsx(TraceLabel, { label: label })) : (_jsx("span", { children: status === 'done' ? text.trace.done(durationSeconds, sourceCount) : text.trace.unfinished(steps.length) })), _jsx(Chevron, { "aria-hidden": "true" })] }), open && steps.length > 0 ? _jsx(TraceSteps, { id: stepsId, label: status === 'unfinished' ? text.trace.unfinishedStepsLabel : text.trace.stepsLabel, steps: steps }) : null] }));
}
